<template>
  <div class="chart__report__print">
    <h3 class="report__title">{{ reportTitle }}</h3>
    <BaseReportForm
      :id="`${reportType}ReportForm`"
      :name="`${reportType}ReportForm`"
      :source="reportSource"
      :form="reportForm"
      :reportType="reportType"
      :viewing="reportForm.finalized"
      :formImages="formImages"
      :key="`${reportType}_print_${formImages.length}`"
      :tik="10000"
      :isPrint="true"
      :isPdf="isPdf"
    ></BaseReportForm>
  </div>
</template>
<script>
import constant from '@/services/constant';
import { mapGetters } from 'vuex';
import BaseReportForm from './BaseReportForm.vue';
import reportSchema from './data.json';

const { REPORT_TYPE } = constant.CHART_REPORT;

export default {
  name: 'ChartReportPrint',
  computed: {
    ...mapGetters('stimulationChart', ['print']),
    reportType() {
      return this.print.reportType;
    },
    reportForm() {
      return this.print.reportForm;
    },
    reportTitle() {
      return this.print.reportTitle;
    },
    formImages() {
      if (this.isPdf) return this.images;
      return this.print.formImages;
    },
    reportSource() {
      if (this.reportType === REPORT_TYPE.ICSI) {
        return reportSchema.ICSIReport;
      }
      if (this.reportType === REPORT_TYPE.STC) {
        return reportSchema.STCReport;
      }
      return reportSchema.IUIReport;
    },
  },
  props: {
    disableAutoPrint: {
      type: Boolean,
      default: false,
    },
    removeStyles: {
      type: Boolean,
      default: true,
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
    images: Array,
  },
  data() {
    return {
      printLocal: false,
    };
  },
  components: {
    BaseReportForm,
  },
  mounted() {
    if (this.removeStyles) {
      // remove all the styles
      const styles = document.querySelectorAll('style');
      styles.forEach(ele => ele.remove());
    }
    (async () => {
      /* eslint-disable */
      if (this.removeStyles) {
        await import('../../assets/bootstrap.min.css');
        await import('element-ui/lib/theme-chalk/index.css');
        await import('../../assets/print/paper.min.css');
      }
      await import('../../assets/print/chart-report.scss');
      /* eslint-enable */

      if (!this.disableAutoPrint) {
        setTimeout(() => {
          window.print();
        }, 2000);
      }
    })();
  },
};
</script>
